import script from "./FitterStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./FitterStatistics.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__